import { FunctionalComponent, h } from '@stencil/core';
import classnames from 'classnames';

interface ImageProps {
    width?: number;
    height?: number;
    src: string;
    alt?: string;
    imageClass?: string;
    fitImage?: boolean;
}

const LazyloadImage: FunctionalComponent<ImageProps> = ({ width, height, src, alt, imageClass = "", fitImage = false }) => {
    const rootClassName = classnames({
        'fit-image': fitImage,
    }, imageClass);
    return (
        <img
            class={rootClassName}
            loading="lazy" // must appear before src in this list to work correctly on firefox
            width={width}
            height={height}
            src={src}
            alt={alt}
        />
    );
}

export default LazyloadImage;
